import {formatWithMask} from 'react-native-mask-input';

export const phoneNumberMask = [
  '+',
  '1',
  ' ',
  '(',
  /\d/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];
/**
 * Custom hook to format North American phone numbers +1(111) 111-1111
 * It also provides a function to un-mask phone numbers in case
 * we need to send raw data to the server
 * @example
 * const {maskNumber,unmaskNumber} = useMaskPhoneNumber();
 * const formattedNumber = maskNumber(string);
 * @returns masked or un-masked phone number
 */
export const useMaskPhoneNumber = () => {
  const formatNumber = (text: string) =>
    formatWithMask({text, mask: phoneNumberMask});

  const maskNumber = (text: string | undefined) =>
    text ? formatNumber(text).masked : undefined;
  const unmaskNumber = (text: string | undefined) =>
    text ? formatNumber(text).unmasked : undefined;

  return {maskNumber, unmaskNumber};
};
